
import SupportOverviewItem from "@/components/SupportOverviewItem.vue";
import IntegrationOverviewItem from "@/components/IntegrationOverviewItem.vue";

export default {
  name: "SupportOverview",
  components: {
    SupportOverviewItem,
    IntegrationOverviewItem,
  },
  props: {
    title: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      required: true,
    },
    supportItems: {
      type: Array,
      required: true,
    },
  },
};
